import React, { FC } from 'react'
import styles from './Tiles.module.scss'
import { TileType } from './types'
import SALink from 'components/SALink'

type TileProps = {
  tile: TileType
}
const TileList: FC<TileProps> = ({ tile }) => {
  const { url, name, imageUrl, linkTitle } = tile
  return (
    <div className={styles.tile}>
      <SALink href={url} title={linkTitle}>
        <img className={styles.image} src={imageUrl} alt={linkTitle} width='314' height='314' />
      </SALink>

      <div className={styles.info}>
        <h6 className={styles.name}>{name}</h6>
        <p className={styles.linkTitle}>
          <SALink href={url} alt={linkTitle}>
            {linkTitle}
          </SALink>
        </p>
      </div>
    </div>
  )
}

export default TileList
